import { type TFunction } from 'i18next';
import {
  getEntries,
  type BelgiumFloodProneArea,
  type BelgiumSpecific,
  type BelgiumSummonsAndRecoveryOrder,
  type BelgiumUrbanPlanningDestination,
  type Listing,
} from '@pkgs/api';

type BelgiumSpecificKey = keyof BelgiumSpecific;
type BelgiumSpecificLabelKey = `search.expose.countrySpecific.label.${BelgiumSpecificKey}`;
type BelgiumSpecificTranslatedContentKey =
  | `search.expose.countrySpecific.floodProneArea.${BelgiumFloodProneArea}`
  | `search.expose.countrySpecific.summonsAndRecoveryOrder.${BelgiumSummonsAndRecoveryOrder}`
  | `search.expose.countrySpecific.urbanPlanningDestination.${BelgiumUrbanPlanningDestination}`;

export const getCountrySpecificDetail = (listing: Listing, t: TFunction<'property_expose'>) => {
  const countrySpecificDetail = listing.countrySpecific?.['be'];
  const countrySpecificEntries = countrySpecificDetail ? getEntries(countrySpecificDetail) : [];

  const countrySpecificInfo = countrySpecificEntries.map(([key, value]) => {
    // oxlint-disable-next-line typescript/no-unnecessary-type-assertion
    const labelKey = `search.expose.countrySpecific.label.${key}` as BelgiumSpecificLabelKey;

    switch (key) {
      case 'summonsAndRecoveryOrder':
      case 'urbanPlanningDestination':
      case 'floodProneArea': {
        const contentKey = `search.expose.countrySpecific.${key}.${value}` as BelgiumSpecificTranslatedContentKey;

        return {
          label: t(labelKey),
          content: t(contentKey),
        };
      }

      default:
        return {
          label: t(labelKey),
          content:
            typeof value === 'boolean' ? (value ? t('search.general.label.yes') : t('search.general.label.no')) : (value?.toString() ?? ''),
        };
    }
  });

  return countrySpecificInfo;
};
